import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  Spinner,
  InputGroup,
  Button,
  Form,
  ListGroup
} from 'react-bootstrap';

import PriceConatainer from "./PriceConatainer";
import CheckoutModal from "./CheckoutModal";

const COM_RATE = 0.1;

const CheckoutPage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isCalculatingPrice, setIsCalculatingPrice] = useState(true);
  const [productData, setProductData] = useState();
  const [currencies, setCurrencies] = useState();
  const [selectedCurrency, setSelectedCurrency] = useState('BTC');
  const [selectedDenomination, setSelectedDenomination] = useState(location.state.productData.minimum_value);
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState({});
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [networkName, setNetworkName] = useState('bitcoin');
  const [isInvalidInputMax, setIsInvalidInputMax] = useState(false);
  const [isInvalidInputMin, setIsInvalidInputMin] = useState(false);
  const [img, setImg] = useState(location.state.productData?.card_image_url);

  useEffect(() => {
    // correct some of GT's errors.
    const imgUrl = location.state.productData?.card_image_url;
    const imgUrlArray = imgUrl.split('.');
    if (imgUrlArray[imgUrlArray.length - 1] === 'pngg') {
      setImg(imgUrl.slice(0, imgUrl.length - 1));
    }
  }, [])

  const goBack = () => {
    navigate(-1);
  };

  const calculatePrice = async () => {
    const exchangeRateData = await axios(`${process.env.REACT_APP_HOSTNAME}/api/payments/coingate/rate/${location.state.productData.currency_code}/${selectedCurrency}`, {
      headers: {
        'Authorization': 'Bearer ' + process.env.REACT_APP_TOKEN,
        'Content-Type': 'application/json'
      }
    });
    const exchangeRate = exchangeRateData.data;
    return {
      price: ((1 + COM_RATE) * selectedDenomination * exchangeRate).toPrecision(6),
      total: ((1 + COM_RATE) * selectedDenomination * exchangeRate * quantity).toPrecision(6)
    };
  };

  useEffect(() => {
    setProductData(location.state.productData);

    // fetching available currencies
    axios.get(process.env.REACT_APP_HOSTNAME + '/api/payments/coingate/currencies', {
      headers: {
        'Authorization': 'Bearer ' + process.env.REACT_APP_TOKEN,
        'Content-Type': 'application/json'
      }
    })
      .then((data) => {
        setCurrencies(data.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    setIsCalculatingPrice(true);
    // default currency is BTC, fetching exchange rate and calculating price
    calculatePrice()
      .then(price => {
        setPrice(price)
      })
      .catch(err => console.log(err))
      .finally(setIsCalculatingPrice(false));
  }, [selectedDenomination, quantity, selectedCurrency])

  const selectDenomination = (e) => {
    e.currentTarget.closest('.checkout-denominations-list-container').querySelector('.active').classList.remove('active');
    e.currentTarget.classList.add('active');
    setSelectedDenomination(e.currentTarget.getAttribute('denomination'));
  };

  const selectDenominationFromRange = (e) => {
    if (/^(?:[1-9]\d*|\d)$/.test(+e.target.value)) {
      setIsInvalidInputMax(false);
      setIsInvalidInputMin(false);
      setSelectedDenomination((+e.target.value).toFixed(2));
      if (+e.target.value > productData.maximum_value) {
        setIsInvalidInputMax(true);
      }
      if (+e.target.value < productData.minimum_value) {
        setIsInvalidInputMin(true);
      }
    }
    // if (/^(?:[1-9]\d*|\d)$/.test(+e.target.value) &&
    //     +e.target.value > productData.maximum_value) {
    //   setSelectedDenomination((+productData.maximum_value).toFixed(2));
    // }
    // if (/^(?:[1-9]\d*|\d)$/.test(+e.target.value) &&
    //     +e.target.value < productData.minimum_value) {
    //   setSelectedDenomination((+productData.minimum_value).toFixed(2));
    // }
  }

  const onSelectCurrency = (currencySymbol, currencyName) => {
    setSelectedCurrency(currencySymbol);
    setNetworkName(currencyName.toLowerCase().replace(' ', ''));
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };
  const increaseQuantity = () => {
    if (quantity < 10) {
      setQuantity(prev => prev + 1);
    }
  };

  const validateEmail = () => {
    if (isInvalidInputMax || isInvalidInputMin) return;
    const form = document.querySelector('#emailForm');
    const isValid = form.checkValidity();
    if (isValid) {
      setEmailInvalid(false);
      return true;
    } else {
      setEmailInvalid(true);
      scrollToValidationMessage();
      return false;
    }
  };
  useEffect(() => {
    if (emailInvalid) {
      scrollToValidationMessage();
    }
  }, [emailInvalid])
  const scrollToValidationMessage = () => {
    const message = document.querySelector('#emailInvalidMessage');
// const yOffset = 100; 
// const y = message.getBoundingClientRect().top + window.pageYOffset ;

//     window.scrollTo({top: y, behavior: 'smooth'});
    message.parentNode.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
  }

  return (
    <div
      className="mb-3 card-container"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        overflow: 'hidden',
        paddingBottom: 20
      }}
    >
      {isLoading ? (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div style={{height: '100%', paddingTop: '0px', overflowY: 'scroll'}}>
          <div className="px-3 pt-3" style={{
            // paddingBottom: '20px'
          }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-end'
              }}
            >
              <span
                style={{
                  fontWeight: 700
                }}
              >My Purchase</span>
              <div className="main-subheader" style={{fontWeight: 400}}>BUY GIFT CARDS WITH CRYPTO</div>
            </div>
          </div>

          <div
              className="px-3 mx-3 my-3 py-2"
              style={{
                display: 'flex',
                flexDirection: 'row',
                // justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px',
                backgroundColor: '#253136'
              }}
            >
              <div style={{flex: 1, borderRadius: 4, overflow: 'hidden'}}>
                <img
                  src={img || 'https://crm.globetopper.com/brandImages/61086a9b755fc.png'}
                  className="img-fluid"
                  alt=""
                  style={{
                    // width: '33.333333%',
                    aspectRatio: '16 / 9'
                  }}
                />
              </div>
              <div
                style={{
                  flex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  marginTop: '15px',
                  marginBottom: '15px',
                  alignItems: 'flex-start',
                  paddingLeft: 15
                }}
              >
                <h5 style={{
                  textAlign: 'left',
                  marginBottom: '10px',
                  fontWeight: 700,
                  fontSize: 20
                }}>
                  {productData.name}
                </h5>
                {productData.denomination_type === 'fixed' && (
                  <span className="item-price-label">
                    {+(productData.minimum_value) + ' ' + productData.currency_code}
                  </span>
                )}
                {productData.denomination_type === 'open' && (
                  <div className="checkout-range-container">
                    <div className="checkout-range-value-container">
                      <div>
                        <div className="gcnhub-range-input-container">
                          <input
                            className="gcnhub-range-input"
                            aria-label="Example text with button addon"
                            aria-describedby="basic-addon1"
                            value={+selectedDenomination}
                            min={+productData.minimum_value}
                            max={+productData.maximum_value}
                            onChange={selectDenominationFromRange}
                          />
                          <Form.Label>{productData.currency_code}</Form.Label>
                        </div>
                      </div>
                      <div style={{position: 'relative'}}>
                        {isInvalidInputMax && (
                          <div className="gcnhub-range-input-invalid-label-max">
                            Max {(+productData.maximum_value).toFixed(0)} {productData.currency_code}
                          </div>
                        )}
                        {isInvalidInputMin && (
                          <div className="gcnhub-range-input-invalid-label-max">
                            Min {(+productData.minimum_value).toFixed(0)} {productData.currency_code}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

              </div>
              <div className="checkout-quantity-container">
                  <InputGroup className="quantity-input-container mb-3">
                    <div
                      variant="gcn-outline-primary"
                      id="button-decrease-quantity-open"
                      onClick={decreaseQuantity}
                    >
                      -
                    </div>
                    <div style={{width: 40, height: 40}}><Form.Control
                      aria-label="Example text with button addon"
                      aria-describedby="basic-addon1"
                      value={quantity}
                      max={10}
                      min={1}
                      disabled
                    /></div>
                    <div
                      variant="gcn-outline-primary"
                      id="button-increase-quantity-open"
                      onClick={increaseQuantity}
                    >
                      +
                    </div>
                  </InputGroup>
                </div>
            </div>

          <p className="px-3 mt-4">Pay with</p>

          {/* open */}
          {productData.denomination_type === 'open' && (
            <div className="checkout-range-container mx-3">
              <div className="checkout-range-price-container">
                <PriceConatainer
                  currencies={currencies}
                  isCalculatingPrice={isCalculatingPrice}
                  price={price}
                  selectedCurrency={selectedCurrency}
                  onSelectCurrency={onSelectCurrency}
                />
              </div>
            </div>
          )}

          {/* fixed */}
          {productData.denomination_type === 'fixed' && (
            <div className="checkout-fixed-container mx-3">
              <div className="checkout-fixed-price-container">
                <PriceConatainer
                  currencies={currencies}
                  isCalculatingPrice={isCalculatingPrice}
                  price={price}
                  selectedCurrency={selectedCurrency}
                  onSelectCurrency={onSelectCurrency}
                />
              </div>
            </div>
          )}

          <p className="px-3 mt-4">Your email address</p>
          
          <Form
            noValidate
            id="emailForm"
            style={{
              margin: '10px 0 90px 0'
            }}
            className="px-3"
          >
            <Form.Group  className="mb-3" controlId="exampleForm.ControlInput1">
              <InputGroup hasValidation>
                <Form.Control
                  type="email"
                  placeholder="name@example.com"
                  onChange={e => setEmail(e.target.value)}
                  required
                  isInvalid={emailInvalid}
                />
                <Form.Control.Feedback id="emailInvalidMessage" type="invalid">
                  Please enter a valid email address
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Form>

          <div 
            className="button-container"
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              textAlign: 'center',
              paddingTop: '20px',
              zIndex: 10
            }
          }>
            <CheckoutModal
              paymentPrice={price.total}
              paymentCurrency={selectedCurrency}
              initialCurrencyCode={productData.currency_code}
              deliveryEmail={email}
              productCode={productData.code}
              quantity={quantity}
              amount={selectedDenomination}
              validateEmail={validateEmail}
              productName={productData.name}
              networkName={networkName}
              goBack={goBack}
            />
        </div>
      </div>
      )}
    </div>
  );
};

export default CheckoutPage;
